import { Store } from 'libx';
import { computed, observable, action } from 'mobx';

import { TREE_EVENTS } from 'shared/dictionaries/events';

export default class AppStore extends Store {

  widgetKind = 'tree';
  __origin_countries = {};

  @observable isTreeReady = false;
  @observable hasApiError = false;
  @observable isOriginError = false;
  @observable isTooManyRequests = false;
  @observable retryAfter = 0;

  @observable messageText = '';
  @observable messageTimeout = null;

  @observable widgetOrigin = document.referrer;

  @computed
  get queryParamsStore() {
    return this.rootStore.queryParamsStore;
  }

  @computed
  get countryStore() {
    return this.rootStore.countryStore;
  }

  @computed
  get apiKey() {
    return this.queryParamsStore.apiKey;
  }

  @computed
  get dominantMode() {
    return this.queryParamsStore.dominantMode;
  }

  @computed
  get theme() {
    return this.queryParamsStore.theme;
  }

  @computed
  get treeStore() {
    return this.queryParamsStore.treeStore;
  }

  @computed
  get dataStore() {
    return this.treeStore;
  }

  @computed
  get dense() {
    return this.queryParamsStore.dense;
  }

  @computed
  get closeType() {
    return this.queryParamsStore.closeType;
  }

  @computed
  get disableInfo() {
    return this.queryParamsStore.disableInfo;
  }

  @computed
  get onDate() {
    return this.queryParamsStore.date;
  }
  set onDate(value) {
    this.queryParamsStore.date = value;
  }

  @computed
  get direction() {
    return this.queryParamsStore.direction;
  }
  set direction(value) {
    this.queryParamsStore.direction = value;
  }

  @computed
  get clearanceCountry() {
    return this.queryParamsStore.clearanceCountry;
  }
  set clearanceCountry(value) {
    this.queryParamsStore.clearanceCountry = value;
  }

  @computed
  get originCountry() {
    return this.queryParamsStore.originCountry;
  }
  set originCountry(value) {
    this.queryParamsStore.originCountry = value;
  }

  @computed
  get countries() {
    return this.countryStore.countries;
  }
  
  @computed
  get isLoadCountries() {
    return this.countryStore.isLoadCountries;
  }

  @computed
  get infoCode() {
    return this.queryParamsStore.infoCode;
  }
  set infoCode(value) {
    this.queryParamsStore.infoCode = value;
  }

  @computed
  get treeLink() {
    return this.queryParamsStore.treeLink;
  }
  set treeLink(value) {
    this.queryParamsStore.treeLink = value;
  }

  @computed
  get treeLinkTarget() {
    return this.queryParamsStore.treeLinkTarget ;
  }
  set treeLinkTarget(value) {
    this.queryParamsStore.treeLinkTarget = value;
  }
  
  @computed
  get isBlink() {
   return this.queryParamsStore.isBlink;
  }
  set isBlink(value) {
    this.queryParamsStore.isBlink = value;
  }

  @computed
  get isSearchOpen() {
    return this.queryParamsStore.searchOpen;
  }
  set isSearchOpen(value) {
    this.queryParamsStore.searchOpen = value;
  }

  @computed
  get searchTerm() {
    return this.queryParamsStore.searchTerm;
  }
  set searchTerm(value) {
    this.queryParamsStore.searchTerm = value;
  }

  @computed
  get expandedNodes() {
    return this.queryParamsStore.expanded;
  }
  set expandedNodes(value = []) {
    this.queryParamsStore.expanded = value;
  }

  @action.bound
  showApiError({ code, text, body, retryAfter }) {
    this.hasApiError = true;

    if (code === 406) {
      this.isOriginError = true;
    }
    if (code === 429) {
      this.isTooManyRequests = true;
      this.retryAfter = retryAfter;
    }
  }

  @action.bound
  clearApiErrors() {
    this.hasApiError = false;
    this.isOriginError = false;
    this.isTooManyRequests = false;
    this.retryAfter = 0;
  }

  @action.bound
  updateExpandedNodes() {
    this.expandedNodes = this.treeStore.nodes.filter(n => n.isTarget && n.branchIsExpanded).map(n => n.id);
  }

  scrollToNode(node, delay = 500) {
    window.setTimeout(() => {
      const nodeElement = document.querySelector(`[data-node-id="${node.id}"]`);
      if (nodeElement) {
        nodeElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
      }
    }, delay);
  }

  clearFlashHighlight() {
    this.dataStore.nodes.items.forEach(node => node.isFlashed = false);
  }

  sendEvent(name, details) {
    if (TREE_EVENTS.includes(name) && window.parent && typeof window.parent.postMessage === 'function') {
      window.parent.postMessage({ name, details }, '*');
    }
  }

}



// WEBPACK FOOTER //
// ./src/stores/AppStore.js